
































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetImageCate2,
  UploadImage,
  getImages,
  delImages,
  UploadVideo,
} from "@/request/home";
import * as OSS from "ali-oss";
@Component({
  components: {
    MainHeader,
    Pagination,
  },
})
export default class Tupian extends Vue {
  private cate1: any = {};
  private cate2List: any = [];
  private currentCate2: any = "";
  private iszhankai: any = true;
  private selectAll: any = false;
  private totalNum: any = 100;
  private pageSize: any = 12;
  private limitedNumber: any = 3;
  private acceptedType: any = "";
  private currentPage: any = 1;
  private noMsg: any = false;
  private data: any = [];
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  /**
   * @description 判断是否为图片需要展示
   */
  private ifVedio(file) {
    const arr: any = ["avi", "mov", "rmvb", "flv", "mp4"];
    let exsit = false;
    arr.map((type: any) => {
      if (file.url.indexOf(type) !== -1) {
        exsit = true;
      }
    });
    return exsit;
  }
  /**
   * @description 预览照片
   */
  private open(url) {
    window.open(url);
  }
  /**
   * @description 切换选择全部
   */
  private selectA(e) {
    this.data.forEach((ele) => {
      ele.checked = e;
    });
  }
  /**
   * @description 图片选择状态改变
   */
  private change(e) {
    if (!e) {
      this.selectAll = false;
    }
    this.$forceUpdate();
  }
  /**
   * @description 删除图片
   */
  private deleteImg() {
    let text = "";
    if (this.cate1.dir_name === "健康宣讲视频") {
      text = "视频";
    } else {
      text = "图片";
    }
    let num = 0;
    this.data.forEach((ele) => {
      if (ele.checked) {
        num++;
      }
    });
    if (num === 0) {
      this.$message({
        type: "warning",
        message: `请先选择需要删除的${text}!`,
      });
      return;
    }
    this.$confirm(`是否确认删除${num}张${text}?`, "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    }).then(() => {
      const arr: any = [];
      this.data.forEach((ele) => {
        if (ele.checked) {
          arr.push(ele.id);
        }
      });
      console.log(arr);
      const params: any = {
        data: {
          image_ids: arr,
        },
      };
      delImages(this, params).then((res) => {
        this.getImgList();
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    });
  }
  /**
   * @description 限制用户上传的图片格式和大小
   */
  private beforeUpload(file) {
    if (this.cate1.dir_name !== "健康宣讲视频") {
      const acceptedType = ".jpg,.png,.jpeg";
      const arr = file.name.split(".");
      const fileType = arr[arr.length - 1];
      const isJPG = acceptedType.includes(fileType);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error("上传图片只能是jpg,png或者jpeg格式!");
      }
      // if (!isLt10M) {
      //   this.$message.error("上传头像图片大小不能超过 10MB!");
      // }
      // return isJPG && isLt10M;
      return isJPG;
    } else {
      const acceptedType = ".avi,.avi,.rmvb,flv,mp4";
      const arr = file.name.split(".");
      const fileType = arr[arr.length - 1];
      const isVedio = acceptedType.includes(fileType);
      if (!isVedio) {
        this.$message.error("上传视频只能是avi,avi,rmvb,flv或者mp4格式!");
      }
      return isVedio;
    }
  }
  /**
   * @description 上传
   */
  private upload(d) {
    if (this.cate1.dir_name !== "健康宣讲视频") {
      const loading = this.$loading({
        lock: true,
        text: "上传中!",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const uploadFilePath: any = "ds/file/" + d.file.name;
      const params: any = {
        type: "file",
        project_id: this.$store.state.center.project_id,
        cate1: this.cate1.id,
        cate2: this.currentCate2.id,
        base64_image: "",
      };
      const reader = new FileReader();
      reader.readAsDataURL(d.file);
      reader.onload = (e: any) => {
        params["base64_image"] = e.target["result"];
        UploadImage(this, params).then((data: any) => {
          loading.close();
          this.getImgList();
        });
      };
    } else {
      const loading = this.$loading({
        lock: true,
        text: "上传中!",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const fileObj = d.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("type", "video");
      form.append("project_id", this.$store.state.center.project_id);
      form.append("cate1", this.cate1.id);
      form.append("cate2", this.currentCate2.id);
      form.append("file", fileObj);
      UploadVideo(this, form)
        .then((data: any) => {
          loading.close();
          this.getImgList();
        })
        .catch((err) => {
          loading.close();
        });
    }
  }
  /**
   * @description 获取图片采集二级目录列表
   */
  private getImageCate2() {
    const loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        id: this.cate1.id,
      },
    };
    GetImageCate2(this, params).then((data: any) => {
      this.cate2List = data;
      if (data.length > 0) {
        this.currentCate2 = data[0];
      } else {
        this.currentCate2 = [];
      }
      loading.close();
      this.getImgList();
    });
  }

  private getImgList() {
    this.data = [];
    const loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      first_id: this.cate1.id,
      second_id: this.currentCate2.id,
      current_page: this.currentPage,
      page_num: this.pageSize,
    };
    getImages(this, params).then((res) => {
      this.totalNum = res.total_count;
      this.data = res.data;
      if (res.data.length === 0) {
        this.noMsg = true;
      } else {
        this.noMsg = false;
      }
      loading.close();
    });
  }
  private handleCurrentPageChange(e) {
    this.currentPage = e;
    this.getImgList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // this.createOss();
    this.cate1 = {
      dir_name: this.$route.query.cateName,
      id: this.$route.query.cateId,
    };
    this.getImageCate2();
  }
}
